import { Dialog, DialogActions, DialogContent, Button } from "@mui/material";
import classes from "./SelectOnePropertyModal.module.scss";
import { ErrorOutlinedIcon } from "@/assets/icons/ErrorOutlinedIcon";
import { SelectOnePropertyDropdown } from "../SelectOnePropertyDropdown/SelectOnePropertyDropdown";
import clsx from "clsx";
import { useState, MouseEvent } from "react";
import { IListing } from "@/views/interfaces";
import { useDispatch } from "react-redux";
import { SET_SELECTED_LISTINGS } from "@/redux/actions";

export const SelectOnePropertyModal = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: VoidFunction;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [selectedListing, setSelectedListing] = useState<IListing | null>(null);

  const dispatch = useDispatch();

  const openPopupHandler = ({ currentTarget }: MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(currentTarget);

  const closePopupHandler = () => setAnchorEl(null);

  const selectListingHandler = (listing: IListing) => () => {
    setSelectedListing(listing);
    closePopupHandler();
  };

  const resetListingHandler = () => {
    setSelectedListing(null);
  };

  const chooseListingHandler = () => {
    dispatch({
      type: SET_SELECTED_LISTINGS,
      payload: { listings: [selectedListing] },
    });
    handleClose();
  };

  return (
    <Dialog classes={{ paper: classes.modalContainer }} open={open}>
      <DialogContent className={classes.modalBody}>
        <div className={classes.iconContainer}>
          <ErrorOutlinedIcon />
        </div>
        <h2 className={classes.title}>Only One Property Allowed</h2>
        <p className={classes.info}>
          You can select only one property at a time.
        </p>
        <SelectOnePropertyDropdown
          anchorEl={anchorEl}
          selectedListing={selectedListing}
          onClose={closePopupHandler}
          onMenuOpen={openPopupHandler}
          onSelect={selectListingHandler}
        />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          className={clsx(classes.button, classes.resetButton)}
          color="secondary"
          onClick={resetListingHandler}
          variant="contained"
        >
          Reset
        </Button>
        <Button
          className={classes.button}
          onClick={chooseListingHandler}
          variant="contained"
          disabled={!selectedListing}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};
